import LogAPI from './log.api'

export default LogAPI
